import { memo } from "react";

type CardAccent = "email" | "calendar" | "success" | "confirm" | "error" | "sheets" | "docs";
type CardStatus = "streaming" | "ready" | "error";

interface CardShellProps {
  icon: string;
  title: string;
  badge?: string;
  accent: CardAccent;
  status?: CardStatus;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export const CardShell = memo(function CardShell({
  icon,
  title,
  badge,
  accent,
  status = "ready",
  actions,
  children,
}: CardShellProps) {
  const ACCENT_CLASS: Record<CardAccent, string> = {
    email: "tool-card--email",
    calendar: "tool-card--calendar",
    success: "tool-card--success",
    confirm: "tool-card--confirm",
    error: "tool-card--error",
    sheets: "tool-card--sheets",
    docs: "tool-card--docs",
  };
  const accentClass = ACCENT_CLASS[accent];

  const statusClass =
    status === "streaming"
      ? " tool-card--streaming"
      : status === "error"
        ? " tool-card--error-state"
        : "";

  return (
    <div className={`tool-card ${accentClass}${statusClass}`} role="article" aria-label={title}>
      <div className="tool-card__header">
        <div className="tool-card__title">
          <span className="tool-card__icon" aria-hidden="true">{icon}</span>
          <span className="tool-card__name">
            {title}
            {status === "streaming" && (
              <span className="streaming-dots" aria-hidden="true" />
            )}
          </span>
        </div>
        {badge && (
          <span className="tool-card__badge">{badge}</span>
        )}
      </div>
      <div className="tool-card__body" aria-live="polite">
        {children}
      </div>
      {actions && (
        <div className="tool-card__actions">
          {actions}
        </div>
      )}
    </div>
  );
});
